export enum SearchDateType { FILL_DATE = 1, SOLD_DATE = 2, TRANSMITTED_DATE = 3 }
import { IDictionary } from '../Shared/dictionary'

export class ServiceEventAdvancedSearchCriteria {

    public MaxDays: number;

    public DayVarianceArray: string[] = [];

    public DateTypeDictionary: IDictionary<string> = {1 : 'Fill Date', 2: 'Sold Date', 3: 'Transmitted Date' };

    public DateType: string;

    public DayVariance: string;

    public NCPDPMatch: boolean;

    public RxMatch: boolean;

    public CarrierOrCarrierGroupMatch: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/serviceEventAdvancedSearchCriteria.model.ts